/**
 * Confirmação de uma ação que não se desfaz com um clique: diz o que acontece e deixa a saída
 * "Cancelar" à vista. Por padrão o botão de confirmar é discreto (contorno, cor de alerta): ação
 * que apaga não deve chamar o olhar. Ação reversível passa `confirmColor="primary"` e ganha o
 * botão cheio.
 */
import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel: string;
  confirmColor?: 'error' | 'warning' | 'success' | 'primary';
  cancelLabel?: string;
  loading?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog: React.FC<Props> = ({
  open,
  title,
  message,
  confirmLabel,
  confirmColor = 'warning',
  cancelLabel = 'Cancelar',
  loading = false,
  error = null,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
      <DialogContentText>{message}</DialogContentText>
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onCancel} disabled={loading}>
        {cancelLabel}
      </Button>
      <Button variant={confirmColor === 'primary' ? 'contained' : 'outlined'} color={confirmColor} onClick={onConfirm} disabled={loading}>
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
